import React from 'react';
import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroBanner from "../components/admission-form/HeroBanner";
import AdmissionProcess from "../components/admission-form/AdmissionProcess";
import PaymentOptions from "../components/admission-form/PaymentOptions";
import AdmissionFormSec from "../components/admission-form/AdmissionFormSec";


export default function AdmissionForm() {

    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate("/terms-conditions");
    };

    return (
        <>
            <Header />

            <HeroBanner />

            <AdmissionProcess />

            <PaymentOptions />

            <AdmissionFormSec />

            <section id="terms-info-section">
                <div className="terms-info-container">
                    <div className="terms-info-content">
                        <p>Read full Terms & Condition, & Privacy and Policy here. Filling the application form will mean that you agree to the all the terms and policies. Click the button below read them.</p>

                        <p>Once you have filled out the application form, please submit it using the designated method (e.g., online submission, email attachment) or contact us directly if you have any questions or need assistance. We will review your application and get in touch with you regarding the next steps.</p>

                        <p>Thank you for your interest in applying to Strumming Tunes Music Academy (STMA)! Please complete the application form below to begin your journey with us. We look forward to welcoming you into our vibrant musical community.</p>

                        <button className="rules-btn" onClick={handleRedirect}>RULES & REGULATIONS</button>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}